import React, { useState, useContext, useEffect } from 'react'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import AuthContext from '@/product/context/auth/authContext'
import InvoiceCard from '@/custom/components/molecules/InvoiceCard'
import NoRecordsFound from '@/custom/components/atoms/NoRecordsFound'
import { Pagination } from '@material-ui/lab'
import DashboardLayout from '@/views/Dashboard/DashboardLayout'
import CustomTable from '@/product/components/molecules/CustomTable'
import { mapData, formatPhone } from '@/product/common/components'
import * as Yup from 'yup'
import {
    dateTimeFormatFunction,
    capitalize,
    paymentTypeRosoom,
    dateFormatFrontOnlyDate,
    handleRedirectInternal,
    currencyFormat,
} from '@/custom/common/components'
import Lottie from 'react-lottie'
import successAnimation from '@/product/lottie/successAnimation.json'
import { useHistory } from 'react-router-dom'
import ProductContext from '@/product/context/product/productContext'
import { Button, ListItem } from '@material-ui/core'
import { useFormik } from 'formik'
import SEO from '@/utils/SEO'
import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/custom/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Scheduler from './schedule'
import SchedulePickupContext from '@/product/context/schedulePickup/schedulePickupContext'
import AlertContext from '@/product/context/alert/alertContext'

const bull = (
    <Box component="span" sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}>
        •
    </Box>
)

const PickupManage = (props) => {
    let [viewProduct, setViewProduct] = useState([])
    const [tableBody, setTableBody] = useState([])
    const [dataArray, setDataArray] = useState([])
    const [pickupPopup, setPickupPopup] = useState(false)
    const authContext = useContext(AuthContext)
    const invoiceContext = useContext(InvoiceContext)
    const { search_alluserinvoices, getAllUserInvoices } = invoiceContext
    const scheduleContext = useContext(SchedulePickupContext)
    const { addSchedulePickup, responseStatus, clearResponse } = scheduleContext
    const customCommonContext = useContext(CustomCommonContext)
    const { setCurrentMembership, allBiddingPlan, membership, alldata_all_dropdown, allLocations } =
        customCommonContext
    const productContext = useContext(ProductContext)
    const {
        search_alldashboardproducts,
        getAllDashboardProducts,
        responseStatus: responseStatusProduct,
    } = productContext
    const { user, isAuthenticated } = authContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [isLoading, setIsLoading] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const [selectedLocation, setSelectedLocation] = useState([])
    const [dateCalendar, setDateCalendar] = useState(false)
    const [customDate, setCustomDate] = useState(false)
    const history = useHistory()

    const validationArray = Yup.object({
        name: Yup.string().required('Required'),
        email: Yup.string().email('Invalid Email Format').required('Required'),
        phone: Yup.string()
            .trim()
            .min(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .max(17, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required'),
        // phone: Yup.string()
        //     .trim()
        //     .min(10, 'Please enter correct mobile number')
        //     .max(17, 'Please enter correct mobile number')
        //     .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
        //     .required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            invoice_id: '',
            user_id: '',
            location_id: '',
            schedule_status: 'booking',
            booking_start_date: '',
            booking_end_date: '',
            reschedule: 0,
            name: '',
            email: '',
            phone: '+1',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (activeStep == 1) {
                setActiveStep(2)
            } else if (activeStep == 2) {
                if (values.booking_start_date === '' && values.booking_end_date === '') {
                    setAlert('Kindly Select Date and Time', 'error')
                } else {
                    // values.booking_start_date =
                    addSchedulePickup(values)
                }
            }
        },
    })

    const handlePickup = () => {
        setActiveStep(0)
        formik.handleReset()
        props.handlePickup()
    }

    const updateFunc = (data, end) => {
        formik.values.booking_start_date = data
        formik.values.booking_end_date = end
    }

    const handleCheckPopup = () => {
        setCheckPopup(!checkPopup)
        setSchedId('')
    }

    useEffect(() => {
        if (responseStatus) {
            setAlert(responseStatus.message, responseStatus.status)
            if (responseStatus.status === 'success' && responseStatus.from === 'addPickup') {
                setActiveStep(3)
                setTimeout(() => {
                    handlePickup()
                    props.getFunction()
                }, 2000)
            }
            clearResponse()
        }
    }, [responseStatus])

    useEffect(() => {
        formik.values.invoice_id = props.invoiceId
        if (props.pickupData && props.pickupData.length) {
            formik.values.reschedule = 1
            formik.values.location_id = props.pickupData[0].schedulepickup_location_id
        } else {
            formik.values.reschedule = 0
            formik.values.location_id = ''
        }
    }, [props.invoiceId, props.pickupData])

    useEffect(() => {
        if (formik.values.location_id !== '') {
            let filteredLoc = allLocations
                .filter((item) => item.active == 1 && item.id == formik.values.location_id)
                .map((data) => {
                    return data
                })
            if (filteredLoc.length) {
                setSelectedLocation(filteredLoc)
            }
        }
    }, [formik.values.location_id])

    useEffect(() => {
        if (props.pickupData && props.pickupData.length) {
            formik.values.user_id = props.pickupData[0].schedulepickup_id
            formik.values.name = props.pickupData[0].schedulepickup_name
            formik.values.email = props.pickupData[0].schedulepickup_email
            formik.values.phone = global.formatPhone
                ? formatPhone(props.pickupData[0].schedulepickup_phone, true)
                : props.pickupData[0].schedulepickup_phone
        } else if (user && Object.keys(user).length) {
            formik.values.user_id = user.id
            formik.values.name = `${user.first_name} ${user.last_name}`
            formik.values.email = user.email
            formik.values.phone = global.formatPhone ? formatPhone(user.phone, true) : user.phone
        }
    }, [user, props.invoiceId, props.pickupData])

    const handleBook = (data) => {
        formik.values.location_id = data
        setActiveStep(1)
    }

    const scheduleData = [
        {
            label: 'Name',
            name: 'name',
            type: 'text',
            placeholder: 'Enter Name',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Email Address',
            name: 'email',
            type: 'email',
            placeholder: 'Enter Your Email Address',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Phone number',
            placeholder: 'Enter your phone number',
            class: 'col-12',
            type: global.formatPhone ? 'number' : 'phone',
            name: 'phone',
            formik: formik,
        },
    ]

    const setSelectedDate = (data) => {
        formik.values.pickupDate = data
    }

    const setSelectedTime = (data) => {
        formik.values.pickupTime = data
    }

    const scheduleSuccessOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: successAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    return (
        <>
            <CustomDialog
                className="fileUploadModal"
                // title={'Schedule Pickup'}
                open={props.pickPopup}
                function={handlePickup}
            >
                {activeStep == 0 ? (
                    <>
                        <h3>Schedule Pickup</h3>
                        {props.pickupData ? (
                            <h4 className="fpTitle">Edit Your Pickup Location</h4>
                        ) : (
                            <h4 className="fpTitle">Choose Your Pickup Location</h4>
                        )}
                        <div className="actionWrapper pickupLocDts">
                            {allLocations
                                .filter((item) => item.active == 1 && item.id == props.locationId)
                                .map((data) => (
                                    <Card
                                        sx={{ minWidth: 275 }}
                                        className={
                                            selectedLocation[0]?.id == data?.id
                                                ? 'selectedLoc'
                                                : null
                                        }
                                    >
                                        <CardContent>
                                            <Typography variant="h5" component="div">
                                                {data.name}
                                            </Typography>
                                            <Typography
                                                sx={{ fontSize: 14 }}
                                                color="text.secondary"
                                                gutterBottom
                                            >
                                                {data.full_address}
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            <PrimaryButton
                                                onClick={() => handleBook(data.id)}
                                                btnSize="small"
                                            >
                                                Schedule An Appointment
                                            </PrimaryButton>
                                        </CardActions>
                                    </Card>
                                ))}
                        </div>
                    </>
                ) : activeStep == 1 ? (
                    <>
                        <h3>Schedule Pickup</h3>
                        <h4 className="fpTitle">Enter Your Details</h4>
                        <div className="row"> {Object.values(mapData(scheduleData))}</div>
                        <PrimaryButton
                            label="NEXT"
                            btnSize="small"
                            onClick={() => formik.handleSubmit()}
                        />
                    </>
                ) : activeStep == 2 ? (
                    <>
                        <h3>Schedule Pickup</h3>
                        <h4 className="fpTitle">Select Date & Time</h4>

                        <Scheduler
                            updateFunc={updateFunc}
                            pickupData={props.pickupData}
                            locationId={formik.values.location_id}
                            pickupDaysLimit={props?.pickupDaysLimit ? props?.pickupDaysLimit : 0}
                            paidDate={props?.paidDate ? props.paidDate : null}
                        />
                        <PrimaryButton
                            label="NEXT"
                            btnSize="small"
                            onClick={() => formik.handleSubmit()}
                        />
                    </>
                ) : (
                    <div className="d-grid text-center">
                        <h3 className="fpTitle clearfix">Booking Confirmed</h3>
                        <Lottie
                            options={scheduleSuccessOptions}
                            speed="1"
                            height={100}
                            width={100}
                        />
                    </div>
                )}
            </CustomDialog>
        </>
    )
}

export default PickupManage
